
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 2500); // Délai de 2.5 secondes
      return () => clearTimeout(timer);
    }
  }, []);

  const handleConsent = (status) => {
    localStorage.setItem('cookie_consent', status);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner-container">
      <div className="cookie-banner shadow-2xl">
        <div className="cookie-content">
          <h4>Vos préférences, votre vie privée</h4>
          <p>
            Nous utilisons des cookies essentiels au fonctionnement du site, ainsi que des 
            cookies analytiques pour vous offrir la meilleure expérience immobilière. 
            Vous pouvez personnaliser vos choix. Pour en savoir plus, consultez notre 
            {' '} <Link to="/politique-de-confidentialite">Politique de Confidentialité</Link>.
          </p>
        </div>
        <div className="cookie-actions">
          <button className="btn-decline" onClick={() => handleConsent('declined')}>Refuser l'essentiel</button>
          <button className="btn-accept" onClick={() => handleConsent('accepted')}>Tout Accepter</button>
        </div>
      </div>

      <style>{`
        .cookie-banner-container {
          position: fixed;
          bottom: 2rem;
          left: 50%;
          transform: translateX(-50%);
          width: calc(100% - 2rem);
          max-width: 900px;
          z-index: 99999;
          animation: slideUpCookie 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }

        .cookie-banner {
          background: rgba(15, 15, 15, 0.9);
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 12px;
          padding: 1.5rem 2rem;
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
          color: #fdfdfd;
        }

        @media (min-width: 768px) {
          .cookie-banner {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
          }
        }

        .cookie-content {
          flex: 1;
        }

        .cookie-content h4 {
          margin: 0 0 0.5rem 0;
          font-size: 1.1rem;
          font-weight: 500;
          letter-spacing: 0.02em;
          color: #fff;
        }

        .cookie-content p {
          margin: 0;
          font-size: 0.85rem;
          line-height: 1.6;
          color: #b3b3b3;
        }

        .cookie-content a {
          color: #ffffff;
          text-decoration: underline;
          text-underline-offset: 3px;
          transition: color 0.2s ease;
        }

        .cookie-content a:hover {
          color: #cfcfcf;
        }

        .cookie-actions {
          display: flex;
          gap: 0.75rem;
          flex-shrink: 0;
        }

        .cookie-actions button {
          cursor: pointer;
          font-family: inherit;
          font-size: 0.85rem;
          font-weight: 500;
          padding: 0.75rem 1.5rem;
          border-radius: 6px;
          transition: all 0.3s ease;
          outline: none;
        }

        .btn-decline {
          background: transparent;
          color: #fff;
          border: 1px solid rgba(255, 255, 255, 0.15);
        }

        .btn-decline:hover {
          background: rgba(255, 255, 255, 0.05);
          border-color: rgba(255, 255, 255, 0.3);
        }

        .btn-accept {
          background: #ffffff;
          color: #000000;
          border: 1px solid #ffffff;
        }

        .btn-accept:hover {
          background: #e6e6e6;
          box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
        }

        @keyframes slideUpCookie {
          from { opacity: 0; transform: translate(-50%, 30px); }
          to { opacity: 1; transform: translate(-50%, 0); }
        }
      `}</style>
    </div>
  );
};

export default CookieBanner;
